import { apiFetch } from "../api/client";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import API from "../config";

const getAuthHeaders = () => {
  const token = localStorage.getItem("access_token");
  return {
    "Content-Type": "application/json",
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  };
};

function DeviceDetailsPage() {
  const { id } = useParams();
  const [device, setDevice] = useState(null);
  const [policies, setPolicies] = useState([]);
  const [selectedPolicy, setSelectedPolicy] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadDevice();
    loadPolicies();
  }, [id]);

  const loadDevice = async () => {
    try {
      setLoading(true);
      const res = await apiFetch(`/devices/${id}`, { headers: getAuthHeaders() });
      const data = res.ok ? await res.json() : null;
      setDevice(data);

      if (data && data.policy_id) {
        setSelectedPolicy(String(data.policy_id));
      }
    } catch (error) {
      console.error("Device details load error:", error);
      setDevice(null);
    } finally {
      setLoading(false);
    }
  };

  const loadPolicies = async () => {
    try {
      const res = await apiFetch(`/policies`, { headers: getAuthHeaders() });
      const data = res.ok ? await res.json() : [];
      setPolicies(Array.isArray(data) ? data : []);
    } catch (error) {
      console.error("Policies load error:", error);
      setPolicies([]);
    }
  };

  const assignPolicy = async () => {
    if (!selectedPolicy) {
      alert("Select a policy first.");
      return;
    }

    try {
      const res = await apiFetch(`/devices/${id}/assign-policy`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          policy_id: Number(selectedPolicy),
        }),
      });

      const data = await res.json();

      if (!res.ok || data.error) {
        throw new Error(data.detail || data.error || "Failed to assign policy");
      }

      alert("Policy assigned successfully");
      loadDevice();
    } catch (error) {
      console.error("Assign policy error:", error);
      alert(error.message);
    }
  };


  if (loading) {
    return <div className="card">Loading device details...</div>;
  }

  if (!device || device.error) {
    return <div className="card">Device not found.</div>;
  }

  return (
    <div>
      <div className="page-actions">
        <h2>{device.device_name || device.hostname || "Device Details"}</h2>
      </div>

      <div className="card">
        <p><strong>Hostname:</strong> {device.hostname || "N/A"}</p>
        <p><strong>Device UUID:</strong> {device.device_uuid || "N/A"}</p>
        <p><strong>Status:</strong> {device.status || "N/A"}</p>
        <p><strong>Platform:</strong> {device.platform || device.os || "N/A"}</p>
        <p><strong>Assigned Policy:</strong> {device.assigned_policy || "Unassigned"}</p>
        <p><strong>Last Check-In:</strong> {device.last_check_in || device.last_seen || "N/A"}</p>
      </div>

      <div className="card">
        <h3>Assign Policy</h3>

        <div className="filter-bar">
          <select
            className="filter-select"
            value={selectedPolicy}
            onChange={(e) => setSelectedPolicy(e.target.value)}
          >
            <option value="">Select Policy</option>
            {policies.map((policy) => (
              <option key={policy.id} value={policy.id}>
                {policy.name}
              </option>
            ))}
          </select>

          <button className="primary-button" onClick={assignPolicy}>
            Assign Policy
          </button>
        </div>
      </div>

      <div className="card">
        <h3>Endpoint Response</h3>
        <p>
          Device response actions are managed through the authenticated
          EDR Response Center. Unsupported legacy lock, reboot, shutdown,
          and refresh-policy action buttons are not exposed from this page.
        </p>

        <div className="filter-bar">
          <a className="primary-button" href="/edr-response">
            Open EDR Response Center
          </a>

          <a className="primary-button" href="/policy-truth">
            View Policy Truth
          </a>

          <a className="primary-button" href="/endpoint-inventory">
            View Endpoint Inventory
          </a>
        </div>
      </div>
    </div>
  );
}

export default DeviceDetailsPage;